module.exports = __webpack_public_path__ + "static/media/14.105.ecc32a31.jpg";